export default __webpack_public_path__ + "static/media/eudemon_logo_240.7e160f21.webp";